<template>
  <div class="system-backup">
    <!-- <tsl-card :cardList="cardList">
      <template v-slot:system>
        <div class="system-backup">
          <div class="item" v-for="(item, index) in overviewList" :key="index">
            <overview-card :name="item.name" :value="item.value" :path="item.path"></overview-card>
            <devops-card :name="item.name" :value="item.value" :path="item.path"></devops-card>
          </div>
        </div>
      </template>
      <template v-slot:topRight>
        <div class="backup-time">最近备份：2022/03/19 14:0</div>
      </template>
    </tsl-card> -->
    <div class="top">
      <div>
        <span class="title">系统备份</span>
        <span class="backup-time">最近备份：2022/03/19 14:00</span>
      </div>
      <more-arrow path="/dashboard/devops/backup/overview" />
    </div>
    <div class="card">
      <div class="item" v-for="(item, index) in overviewList" :key="index">
        <devops-card :name="item.name" :value="item.value" :path="item.path"></devops-card>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/components/tsl-card/index.vue";
// import Ocard from "@/components/overview-card/index.vue";
import Dcard from "@/components/dashboard/devops/devops-card.vue";
import { reactive, ref } from "vue";
import More from "@/components/more-arrow/index";
export default {
  name: "system-backup",
  components: {
    [Card.name]: Card,
    // [Ocard.name]: Ocard,
    [Dcard.name]: Dcard,
    [More.name]: More
  },
  props: {
    data: Object
  },
  setup() {
    const overviewList = ref([
      {
        name: "备份计划",
        value: 0,
        path: "/dashboard/devops/backup/plan"
      },
      {
        name: "备份记录",
        value: 5,
        path: "/dashboard/devops/backup/record"
      }
    ]);
    const cardList = reactive([
      {
        name: "system",
        title: "系统备份",
        topLeft: "topLeft"
      }
    ]);
    return {
      cardList,
      overviewList
    };
  }
};
</script>
<style scoped lang="less">
.system-backup {
  margin-bottom: 16px;
  padding: 24px;
  text-align: left;
  background-color: #fff;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  .top {
    display: flex;
    justify-content: space-between;
    .title {
      margin-bottom: 16px;
      color: #1d2129;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
    }
  }
  .card {
    display: flex;
    margin-top: 17px;
    .item {
      width: 50%;
      margin-right: 16px;
    }
    .item:nth-child(even) {
      margin-right: 0;
    }
  }
  .backup-time {
    margin-left: 16px;
    color: #86909c;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
